{
  "BackToAllBuilders": "volver a todos los builders",
  "Target": "Público objetivo",
  "Step2": "Paso 2 - Asesores",

  "AboutThisBuilder": "Acerca de este  Builder",
  "RebelSkillsGained": "Habilidades rebel ganadas",
  "next": "siguiente",

  "Review": "Revisión",
  "ProfilePreview": "vista previa del perfil",
  "challengeReviewPhrase1": "Regresa y responde algunas preguntas antes de que puedas verlas aquí .",
  "published": "Publicado",
  "WhoCanSeeThis": "Quien puede ver esto?",
  "NothingToPublishYet": "Aún no hay nada para publicar.",
  "TeamOnly": "Solo equipo",
  "MyEvents": "Mis eventos",
  "Everyone": "Cualquier persona",
  "Publish": "Publicar",

  "addOption": "agregar opción",
  "challengeTopicInputPlaceholder": "agregar ideas, garabatos, esquemas, creaciones alucinantes; aquí ",
  "HeadsUp": "Aviso",
  "LastSaved": "Último guardado",
  "by": "por",
  "saving": "Guardando...",
  "save": "guardar",
  "CannotSave": "No se puede guardar. Primero revisa los cambios de tu equipo.",
  "SomeoneHasMadeChanges": "ha realizado cambios en este tema en el que estas trabajando actualmente.",
  "challengeTopicPhrasePart1": "Por favor incorpora",
  "challengeTopicPhrasePart2": "cambios en tu respuesta y",
  "challengeTopicPhrasePart3": "guardala respuesta a continuación ",
  "or": "o",
  "challengeTopicPhrase2Part1": "Aceptar cambios y",
  "use": "utilizar",
  "changes": "cambios",
  "SaveWorkBelow": "guardar respuesta a continuación",
  "BeSureNotToOverwrite": "ha realizado cambios en esto. Ten cuidado de no sobrescribir respuestas importantes .",
  "ConfirmLeavingPage": "¿estás seguro de que quieres salir de esta página? ¡Cualquier respuesta que no se haya guardado se perderá! ",
  "backToTopics": "Volver a temas",
  "skipToAnswer": "Saltar para responder",
  "Section": "Sección",
  "SectionName": "Nombre de la sección",
  "AddSectionContentHere": "agregar el contenido de la sección aquí",
  "GotItNext": "Lo tengo, siguiente",
  "SomeoneElseWorkingOnThis": "también está trabajando en esta pregunta.",
  "SomeoneElseWorkingOnThisBuilder": "  también están trabajando en este builder",

  "rebelMap": "RebelMap principal",
  "OpenAs": "Abierto como",
  "IntroToTarget": "Introducción a Target",
  "Answer": "Responder",
  "OnTrack": "Sección actual",
  "switchTracks": "Cambiar secciones",
  "nextTrack": "Siguiente seccioón",
  "Progress": "Progreso",
  "NoTrackSelected": "Sin sección seleccionada",
  "SelectTrack": "Seleccionar sección",
  "Builders": "Builders",
  "DifficultyLevel": "Nivel de dificultad",
  "JumpBackIn": "Salta hacia atrás ...",
  "Differentation": "Diferenciación / disrupción",
  "BetaProjectPhrase1": "¡Gracias por participar en RebelBase Beta!",
  "BetaProjectPhrase2Part1": "Probablemente ya hayas notado nuestro nuevo look (aceptamos cumplidos",
  "BetaProjectPhrase2Part2": "Pero hemos cambiado más que solo el diseño. Mientras has estado en tus diversas misiones, de vuelta a la base hemos trabajado incansablemente para crear un entorno más interactivo, intuitivo y experiencia iluminadora.",
  "BetaProjectPhrase2Part3": " Así que gracias a todos los probadores beta por proporcionar comentarios en los que se basa la nueva experiencia Rebel, así que ... ",
  "WelcomeToRebelBase": "Bienvenido a RebelBase 1.0.",
  "OneImportantThing": "Una cosa importante.",
  "BetaProjectPhrase3": "Para migrar la información de su proyecto beta, lee esto",
  "BetaProjectPhrase3Part1": "Dado que hicimos cambios significativos en los desafíos y preguntas, esta migración no coincidirá perfectamente. Habrá alguna pérdida de datos. Contáctenos para mas información.",
  "OrPreferToStartFresh": "O si prefieres empezar de nuevo:",
  "BetaProjectPhrase4": " Obtendrás los nuevos desafíos, pero no tus datos antiguos. No podemos deshacer esto.",
  "CopyThat": "Entendido",
  "StartFresh": "Empecemos de nuevo",
  "tracks": "secciones",
  "subject": "Tema",
  "SeeAllBuilders": "Ver todos los builders"
}
